import { WebPortalClient, Study, SubjectCreation, DiarySession } from "webportalclient";
import { UploadStatus } from "./DevicesNewReducer";
import { UploadDiarySessionsAsyncAction } from "./UploadDiarySessionsAsyncAction";
import { NIL } from 'uuid';
import * as P230In2itiveApi from '../misc/api/DeviceLinkApi/P230In2itive';
import * as P230Messages from "../misc/api/DeviceLinkApi/P230In2itiveMessages";
import { Device } from "../misc/api/DeviceLinkApi/Devices";

export const uploadExistingSubjectData = async (client: WebPortalClient, study: Study, selectedDevice: Device, currentDeviceSubject: SubjectCreation, setStatus: React.Dispatch<React.SetStateAction<string>>, onError: (message: string) => void) => {
    let allSessions = [];

    const getSessions = async (lastRecordId?: string): Promise<UploadStatus> => {
        const result = await P230In2itiveApi.GetSession(selectedDevice.id);

        if (result === undefined)
            return UploadStatus.Uploaded;

        if (P230In2itiveApi.isIn2itiveError(result)) {

            return UploadStatus.PartialFailed;
        }

        allSessions.push(...result.eDiarySessions);

        if (result.eDiarySessions.length === 100) {
            const lastId = result.eDiarySessions[result.eDiarySessions.length - 1].id;
            return getSessions(lastId);
        }
        return;
    }

    const status = await getSessions(selectedDevice.id);
    if (status !== undefined)
        return { status: status };

    // HACK: For eDiary version 1.05.0040
    allSessions = allSessions.filter(x => x.id !== NIL);
    // ENDHACK

    const diarySessions: DiarySession[] = allSessions.map(s => {
        return {
            id: s.id,
            visitId: s.visitId,
            name: s.name,
            occurred: s.occurred,
            batteryLevel: s.batteryLevel,
            applicationVersion: s.applicationVersion,
            serialNumber: s.serialNumber,
            pefRepeatable: s.pefRepeatable,
            pefRepeatability: s.pefRepeatability,
            tests: s.tests ? s.tests.map(t => {
                return {
                    id: undefined,
                    sessionId: s.id,
                    occurred: t.occurred,
                    index: t.index,
                    accepted: t.accepted,
                    qualityIndicators: t.qualityIndicators,
                    pef: t.pef,
                    fev1: t.fev1
                }
            }) : undefined,
            questionnaires: s.questionnaires ? s.questionnaires.map(q => {
                return {
                    id: q.id,
                    sessionId: s.id,
                    questionnaireId: q.questionnaireId,
                    score: q.score,
                    occurred: q.occurred,
                    name: q.name,
                    answers: q.answers ? q.answers.map(a => {
                        return {
                            id: undefined,
                            questionnaireTestId: q.id,
                            questionIndex: a.questionIndex.toString(),
                            answerIndex: a.answerIndex.toString(),
                            answerWeight: a.answerWeight,
                            answer: a.answer,
                        }
                    }) : undefined
                }
            }) : undefined
        } as DiarySession;
    });
    const existingSessions = [];
    for (const session of diarySessions) {

        const getSessionById = await client.getSessions(undefined, `id eq ${session.id}`);
        if (getSessionById["@odata.count"] > 0) {
            existingSessions.push(getSessionById.value);
        }
    }

    if (existingSessions.length >= diarySessions.length)
        return UploadStatus.Uploaded;
    setStatus(P230Messages.UploadExistingData);
    return await UploadDiarySessionsAsyncAction.UploadSingle(client, study.id, selectedDevice, diarySessions, currentDeviceSubject, () => { }, (status, message) => status !== UploadStatus.Uploaded ? onError(message) : {});
}
